import $ from "jquery";
$(document).ready(function () {
  $(".c-alert-bar").on("click", function () {
    let parent = $(this).find(".c-alert-bar__wrap");
    if (parent.hasClass("open")) {
      parent.removeClass("open");
      $(this).find(".read-more").html("LEARN MORE");
      $(this).prev().removeAttr("style");
      $(".wp-block-belize-blocks-hero-wrapper").css("margin-bottom", "0rem");
    } else {
      parent.addClass("open");
      $(this).find(".read-more").html("SHOW LESS");
    }
  });
});
